import get from "lodash/get";
import Ajax from "src/ajax";

const path = "user/approve";

/**
 * Actions
 */
const FETCH_REQUEST = `${path}/fetch-request`;
const FETCH_REQUEST_SUCCESS = `${path}/fetch-success`;
const FETCH_REQUEST_FAIL = `${path}/fetch-fail`;

const ACTION_REQUEST = `${path}/action-request`;
const ACTION_REQUEST_SUCCESS = `${path}/action-success`;
const ACTION_REQUEST_FAIL = `${path}/action-fail`;

/**
 * Action Creators
 */

/**
 * Side Effects
 */
export const fetchList = (queries) => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST });
  try {
    const options = {
      method: "GET",
      url: path,
      params: queries,
    };
    const response = await Ajax(options);
    const list = response.data.users;
    const total = response.data.total;
    dispatch({ type: FETCH_REQUEST_SUCCESS, payload: { list, total } });
  } catch (error) {
    const error_text = get(error, "response.data.error");
    // set fetching = false + error text
    dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text });
  }
};

export const approve = (_id) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST });
  try {
    const options = {
      method: "put",
      url: path + "/" + _id,
    };
    // eslint-disable-next-line
    const response = await Ajax(options);
    dispatch({ type: ACTION_REQUEST_SUCCESS });
  } catch (error) {
    const error_text = get(error, "response.data.error");
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text });
    throw error;
  }
};

export const deny = (_id) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST });
  try {
    const options = {
      method: "delete",
      url: path + "/" + _id,
    };
    // eslint-disable-next-line
    const response = await Ajax(options);
    dispatch({ type: ACTION_REQUEST_SUCCESS });
  } catch (error) {
    const error_text = get(error, "response.data.error");
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text });
    throw error;
  }
};

/**
 * Initial State
 */
const initialState = {
  fetching: false,
  list: [],
  total: 0,
  // loading for create & edit
  processing: false,
  error: null,
};

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetching: true, error: null };
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        fetching: false,
        list: action.payload.list,
        total: action.payload.total,
      };
    case FETCH_REQUEST_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case ACTION_REQUEST:
      return { ...state, processing: true, error: null };
    case ACTION_REQUEST_SUCCESS:
      return { ...state, processing: false };
    case ACTION_REQUEST_FAIL:
      return { ...state, processing: false, error: action.payload };

    default:
      return state;
  }
}
